module.exports = __webpack_public_path__ + "static/media/tickCircle.9dd3657b.svg";